import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_PL.json';
import guides from './MEDITATION_GUIDES_PL.json';

export const MEDITATION_DATA_PL: ServiceData = {
  audios,
  guides,
};
